import styled from '@emotion/styled';
import { sendAnalyticsEvent } from 'src/lib/googleAnalytics';
import { onClickGenerator } from 'src/lib/player/utils/onClickGenerator';
import { IconSearch } from '../../BasicComponents/Icons';

export const SearchIconButton = ({ onClick }: { onClick: () => void }) => (
  <SearchIconWrapper
    {...onClickGenerator(() => {
      sendAnalyticsEvent('starter-list-search');
      onClick();
    })}
  />
);

const SearchIconWrapper = styled(IconSearch)`
  position: absolute;
  top: 0;
  left: 0;
  padding: 12px;
  font-size: 16px;
  cursor: pointer;
  transition: transform 0.3s;
`;
